import { useEffect, useState } from "react";

export function createGlobalEventListener<T>(
    event: string,
    getValue: () => T,
    defaultValue: T,
) {
    if (typeof window === "undefined") {
        return () => {
            return defaultValue;
        };
    }

    let value = getValue();
    const hooks = new Set<(val: T) => void>();

    window.addEventListener(event, () => {
        const newValue = getValue();
        if (newValue !== value) {
            value = newValue;
            hooks.forEach((fn) => fn(newValue));
        }
    });

    function useEventValue() {
        const [val, setVal] = useState(value);
        useEffect(() => {
            setVal(value);
            hooks.add(setVal);
            return () => {
                hooks.delete(setVal);
            };
        }, []);
        return val;
    }

    return useEventValue;
}
